module.exports = __webpack_public_path__ + "static/media/Josh Streeter Headshot_1681113602599.9c145c23.jpg";